import { NgModule, ApplicationRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule, AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AuthService } from './providers/auth.service';
import { AuthGuard } from './providers/auth-guard.service';
import { RoleAgentGuard } from './providers/roleagent.guard';
import { RoleAdminGuard } from './providers/roleadmin.guard';
import { RoleService } from './providers/authRole.service';
//import { ContextMenuModule } from 'ngx-contextmenu';


export const firebaseConfig = {
    apiKey: 'AIzaSyD3V35o-RpR68WNrG1_JzdGV-mvp0djpl0',
    authDomain: 'offer-archer.firebaseapp.com',
    databaseURL: 'https://offer-archer.firebaseio.com',
    storageBucket: 'offer-archer.appspot.com',
    messagingSenderId: '166775313304'
  };


/*
 * Platform and Environment providers/directives/pipes
 */
import { routing } from './app.routing';

// App is our top level component
import { App } from './app.component';
import { AppState, InternalStateType } from './app.service';
import { GlobalState } from './global.state';
import { NgaModule } from './theme/nga.module';
import { PagesModule } from './pages/pages.module';


// Application wide providers
const APP_PROVIDERS = [
  AppState,
  GlobalState,
  AuthService,
  AuthGuard,
  RoleAgentGuard,
  RoleAdminGuard,
  RoleService
];

export type StoreType = {
  state: InternalStateType,
  restoreInputValues: () => void,
  disposeOldHosts: () => void
};

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
  bootstrap: [App],
  declarations: [
    App
  ],
  imports: [ // import Angular's modules
    BrowserModule,
    HttpModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgaModule.forRoot(),
    NgbModule.forRoot(),
    PagesModule,
    routing,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    //ContextMenuModule.forRoot()
  ],
  providers: [ // expose our Services and Providers into Angular's dependency injection
    APP_PROVIDERS
  ]
})

export class AppModule {

  constructor(public appState: AppState) {
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts